// extracted by mini-css-extract-plugin
export default {"loadingScreen":"LoginCallback_loadingScreen__AP5jw","error":"LoginCallback_error__z++1N","head":"LoginCallback_head__TcdoS","button":"LoginCallback_button__hgp7j"};